document.addEventListener("DOMContentLoaded", () => {
  const badgeBoxes = document.querySelectorAll(".badge-box");

  badgeBoxes.forEach((badge) => {
    if (badge instanceof HTMLElement) {
      const text = badge.innerHTML.trim();
      if (text.endsWith("!")) {
        badge.innerHTML = text.slice(0, -1);
      }
    }
  });
});
